import { ErrorAlert } from "components/alerts/ErrorAlert"
import { LoadingAlert } from "components/alerts/LoadingAlert"
import { TextInput } from "components/inputs/text/Text"
import { validateInputs } from "components/inputs/validate"
import { useEffect, useState } from "react"
import { Mask } from "utils/mask"
import { ufs } from "utils/ufs"
import { empresasinputs, enderecoinputs, inputs, pagamentoinputs } from "./inputs"
import { SelectField } from "components/inputs/select/Select"
import { Button } from "react-bootstrap"
import { createCompany } from "services/Company/Company"
import { SuccessAlert } from "components/alerts/Success"
import { useNavigate } from "react-router-dom"
import { Checkbox } from "components/inputs/checkbox/Checkbox"

export const RegisterCompany = () => {
  const navigate = useNavigate()

  useState<{ value: string; label: string }[]>([])
  const [errors, setErrors] = useState<{ id: string, error: string }[]>([])
  const [confirmRegister, setConfirmRegister] = useState(
    {
      termos: false,
      lgpd: false
    }
  )
  const [state, setState] = useState({
    logradouro: {
      pais: "Brasil",
      cep: "",
      endereco: "",
      bairro: "",
      cidade: "",
      uf: "",
      numero: "",
    },
    proprietario: {
      cpf_cnpj: "",
      email: "",
      nome: "",
      password: "",
      tipo: "Físico",
      username: "",
      passwordConfirm: "",
    },

    empresa: {
      cpf_cnpj: "",
      tipo: "Jurídico",
      nome_fantasia: "",
      telefone: "",
      nome: "",
    },

    dadosPagamento: {
      formaPagamento: "",
      nome: "",
      cpf_cnpj: "",
      cnpj: "",
      razao_social: "",
      email: "",
      telefone: "",
      cep: "",
      endereco: "",
      bairro: "",
      numero: "",
      cidade: "",
      uf: "",
    },

    capacidade: 60000,
    plano: "",
  })
  const [cities, setCities] = useState<{ value: string, label: string }[]>([])
  const getCitiesToUF = async (UF: string) => {
    try {
      const ufToFind = ufs.find(uf => uf.value === UF)?.value
      return await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${ufToFind}/municipios`)
        .then(async response => {
          LoadingAlert({ show: true })
          const data = await response.json()
          setCities(
            (data as { nome: string }[]).map(city => ({
              value: city.nome,
              label: city.nome
            }))
          )
          LoadingAlert({ show: false })
        })

    } catch (error: unknown) {
      ErrorAlert({ message: error as string })
    }
  }
  const getInfoCNPJ = async (cnpj: string) => {
    try {
      return await fetch(`https://publica.cnpj.ws/cnpj/${cnpj.replace(/\D/g, "")}`)
        .then(async response => {
          LoadingAlert({ show: true })

          const data = await response.json()
          if (response.status === 200) {

            setState((prev) => ({
              ...prev,
              empresa: {
                ...prev.empresa,
                nome_fantasia: data.estabelecimento.nome_fantasia,
                nome: data.razao_social,
                tipo: "JURIDICO",
                telefone: (data.estabelecimento.ddd1 && data.estabelecimento.telefone1 ?
                  new Mask().phone(data.estabelecimento.ddd1 + data.estabelecimento.telefone1) : ""
                )
              },
              logradouro: {
                ...prev.logradouro,
                cep: data.estabelecimento.cep !== "" ? new Mask().cep(data.estabelecimento.cep) : "",
                endereco: data.estabelecimento.logradouro !== "" ? data.estabelecimento.logradouro : "",
                bairro: data.estabelecimento.bairro !== "" ? data.estabelecimento.bairro : ""
              }
            }))
          } else if (response.status === 400) {
            throw new Error("CNPJ inválido")
          } else {
            throw new Error("Erro ao consultar CNPJ.")
          }
          LoadingAlert({ show: false })
        })

    } catch (error: unknown) {
      ErrorAlert({ message: error as string })
    }
  }
  useEffect(() => {
    if (state.empresa.cpf_cnpj.length === 18) {
      getInfoCNPJ(state.empresa.cpf_cnpj)
    }
  }, [state.empresa.cpf_cnpj])

  useEffect(() => {
    console.log(state)
    if (state.logradouro.uf !== "") {
      getCitiesToUF(state.logradouro.uf)
    }
  }, [state.logradouro.uf])
  useEffect(() => {

    const getInfoToCEP = async (cep: string) => {
      try {
        const response = await fetch(
          `https://viacep.com.br/ws/${cep}/json/`
        )

        const data = await response.json()

        if (data?.erro) {
          throw new Error("CEP não encontrado")
        }

        setState((prev) => ({
          ...prev,
          logradouro: {
            ...prev.logradouro,
            endereco: data.logradouro || "",
            bairro: data.bairro || "",
            cidade: data.localidade || "",
            uf: data.uf || "",
          },
        }))
      } catch (error) {
        ErrorAlert({ message: String(error) })
      }
    }
    if (state.logradouro.cep.length === 9) {
      getInfoToCEP(state.logradouro.cep)
    }
  }, [state.logradouro.cep])



  const handleSubmit = async () => {

    const validate = validateInputs(inputs, state, setErrors)
    if (validate.length > 0) {
      ErrorAlert({ message: `Verifique se o campo ${validate[0].label} está preenchido` })
      return
    }
    if (state.proprietario.password !== state.proprietario.passwordConfirm) {
      ErrorAlert({ message: "As senhas digitadas são diferentes" })
      return
    }
    if (state.proprietario.password.length < 8) {
      ErrorAlert({ message: "A senha deve ter no mínimo 8 caracteres" })
      return
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(state.dadosPagamento.email)) {
      const nameField = inputs.find(input => input.name === "dadosPagamento.email")?.label
      ErrorAlert({ message: `Email digitado no campo ${nameField} é inválido` })
      return
    }
    if (!emailRegex.test(state.proprietario.email)) {
      const nameField = inputs.find(input => input.name === "empresa.email")?.label
      ErrorAlert({ message: `Email digitado no campo ${nameField} é inválido` })
      return
    }
    const onlyNumbers = (value: string) => value.replace(/\D/g, "")
    let newState = { ...state }
    newState = {
      ...state,
      proprietario: {
        ...state.proprietario,
        cpf_cnpj: onlyNumbers(state.proprietario.cpf_cnpj),
      },
      empresa: {
        ...state.empresa,
        cpf_cnpj: onlyNumbers(state.empresa.cpf_cnpj),
      },
      dadosPagamento: {
        ...state.dadosPagamento,
        cpf_cnpj: onlyNumbers(state.dadosPagamento.cpf_cnpj),
        "bairro": state.logradouro.bairro,
        "cep": state.logradouro.cep,
        "cidade": state.logradouro.cidade,
        "cnpj": onlyNumbers(state.empresa.cpf_cnpj),
        "endereco": state.logradouro.endereco,
        "formaPagamento": "boleto",
        "numero": state.logradouro.numero,
        "razao_social": state.empresa.nome,
        "telefone": state.dadosPagamento.telefone,
        "uf": state.logradouro.uf
      }
    }
    LoadingAlert({ show: true })
    try {
      await createCompany(newState)
      SuccessAlert({ message: "Empresa cadastrada com sucesso!" })
      navigate("/empresas")
    } catch (e) {
      ErrorAlert({ message: (e as unknown as { response: { data: { message: string } } }).response.data.message })
    }

  }

  return (
    <div className="container-fluid py-3">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="mb-0">CADASTRAR EMPRESA</h2>
      </div>

      <div
        className="p-3 rounded"
        style={{ backgroundColor: "#ebe5d1" }}
      >
        <h5 className="mb-4">Informações da empresa</h5>

        <div className="row g-3">
          {empresasinputs.map((input) => (
            <div
              key={input.id}
              className="col-12 col-md-6 col-lg-4 col-xl-3 "
            >
              {input.component === "TextInput" ? (
                <TextInput
                  error={errors.find(e => e.id === input.id)?.error}
                  id={input.id}
                  label={input.label}
                  name={input.name}
                  placeholder={input.placeholder}
                  required={input.required}
                  type={input.type}
                  mask={input.mask}
                  state={state}
                  setState={setState}
                />
              ) : (
                <SelectField
                  error={errors.find(e => e.id === input.id)?.error}

                  id={input.id}
                  label={input.label}
                  name={input.name}
                  placeholder={input.placeholder}
                  required={input.required}
                  state={state}
                  setState={setState}
                  options={
                    input.options === "ufs"
                      ? ufs
                      : input.options === "cities"
                        ? cities
                        : input.options
                  }
                />
              )}
            </div>
          ))}
        </div>

        <hr className="my-4" />

        <h5 className="mb-4">Endereço</h5>

        <div className="row g-3">
          {enderecoinputs.map((input) => (
            <div
              key={input.id}
              className={
                input.id === "cep" || input.id === "uf"
                  ? "col-12 col-md-4 col-lg-3 col-xl-2"
                  : input.id === "endereco"
                    ? "col-12 col-md-8 col-lg-6 col-xl-5"
                    : "col-12 col-md-4 col-lg-3 col-xl-2"
              }
            >
              {input.component === "TextInput" ? (
                <TextInput
                  {...input}
                  error={errors.find(e => e.id === input.id)?.error}
                  state={state}
                  setState={setState}
                />
              ) : (
                
                <SelectField
                  {...input}
                  error={errors.find(e => e.id === input.id)?.error}
                  state={state}
                  setState={setState}
                  options={
                    input.options === "ufs"
                      ? ufs
                      : input.options === "cities"
                        ? cities
                        : input.options
                  }
                />
              )}
            </div>
          ))}
        </div>

        <hr className="my-4" />

        <h5 className="mb-4">
          Informações do plano {state.plano}
        </h5>

        <div className="row g-3">
          {pagamentoinputs.map((input) => (
            <div
              key={input.id}
              className="col-12 col-md-6 col-lg-4 col-xl-3"
            >
              <TextInput
                {...input}
                error={errors.find(e => e.id === input.id)?.error}
                state={state}
                setState={setState}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="d-flex flex-column align-items-end my-2">
        <Checkbox
          id="termos"
          name="termos"
          setState={setConfirmRegister}
          state={confirmRegister}
          label={
            <>
              Declaro que li e concordo com os{" "}
              <a href="https://sistema.cachacagestor.com.br/landpage/termos.html" target="_blank" rel="noreferrer">
                Termos de Uso
              </a>?
            </>
          }
        />
        <Checkbox
          id="lgpd"
          name="lgpd"
          setState={setConfirmRegister}
          state={confirmRegister}
          label={
            <>
              Declaro que li e concordo com a{" "}
              <a href="https://sistema.cachacagestor.com.br/landpage/termos_lgpd.html" target="_blank" rel="noreferrer">
                Política de Dados
              </a>?
            </>
          }
        />
      </div>
      <div className="d-flex justify-content-between ">
        <Button
          onClick={() => { navigate("/empresas") }}
          style={{ backgroundColor: "#ee2d2d", borderColor: "transparent" }}
        >
          CANCELAR
        </Button>
        <Button
          onClick={handleSubmit}
          style={{ backgroundColor: "#30a151", borderColor: "transparent" }}
          disabled={!(confirmRegister.lgpd && confirmRegister.termos)}
        >
          CADASTRAR
        </Button>
      </div>
    </div>
  )
}